import React from 'react';
import { Route, Switch } from 'react-router';
import { Filter } from '../../../types/main';
import ProjectFilterMenu from './Menus/ProjectFilterMenu';

type FilterValue = string | number | string[];

export type FilterMenusProps = {
  onApply: (filters: FilterValue[][]) => void;
  currentFilters: Filter[];
};

const FilterMenus = (props: FilterMenusProps) => {

  return (
    <Switch>
      <Route path="/dashboard/projects">
        <ProjectFilterMenu {...props} />
      </Route>
    </Switch>
  );
};

export default FilterMenus;
